import React from 'react';
import { ProcessData } from '../services/dashboardApi';

interface ProcessTableProps {
  data: ProcessData[];
}

const ProcessTable: React.FC<ProcessTableProps> = ({ data }) => {

  return (
    <div className="card card-flush h-100 shadow-sm">
      <div className="card-header pt-7 pb-3">
        <h3 className="card-title">
          <span className="card-label fw-bold text-gray-800">Processes</span>
        </h3>
      </div>
      <div className="card-body pt-2" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <div className="table-responsive">
          <table className="table  table-row-dashed gy-4 align-middle fs-7">
            <thead>
              <tr className="fw-bold text-gray-800 bg-light">
                <th className="ps-4 rounded-start">Name</th>
                <th className="text-center">New Job</th>
                <th className="text-center">Total Active</th>
                <th className="text-center">Completed Jobs</th>
                <th className="text-center">Turn Around Time</th>
                <th className="text-center rounded-end">Average Ageing</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td className="ps-4">
                    <span className="text-gray-800 fw-semibold">{item.name}</span>
                  </td>
                  <td className="text-center">
                    <span className="text-gray-700">{item.newJob}</span>
                  </td>
                  <td className="text-center">
                    <span className="text-gray-700">{item.totalActive}</span>
                  </td>
                  <td className="text-center">
                    <span className="text-gray-700">{item.completedJobs}</span>
                  </td>
                  <td className="text-center">
                    <span className="text-gray-700">{item.turnAroundTime}</span>
                  </td>
                  <td className="text-center">
                    <span className="text-gray-700">{item.averageAgeing}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="mt-4 p-3 bg-light rounded">
          <span className="text-gray-700 fs-7">
            Total days of 1350 jobs / 1350
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProcessTable;
